import { syncErrorBus } from './SyncErrorBus';
import { SyncError, SYNC_ERROR_TYPES, ERROR_SOURCES } from './errorTypes';
import { ENABLE_TOKEN_EXPIRED_MODAL, ENABLE_SYNC_ERROR_MODAL } from './constants';

/**
 * Detects token expiration (401 Unauthorized) and triggers the session expired modal.
 * Emits a TOKEN_EXPIRED error through syncErrorBus when the feature flag is enabled.
 * 
 * @param {number} responseStatus - HTTP response status code
 * @param {Object} parsedData - Parsed response body
 */
export function detectTokenExpired(responseStatus, parsedData) {
    if (responseStatus === 401 && parsedData?.message === "Unauthorized") {
        if (ENABLE_TOKEN_EXPIRED_MODAL) {
            syncErrorBus.emit(new SyncError(
                SYNC_ERROR_TYPES.TOKEN_EXPIRED,
                ERROR_SOURCES.API
            ));
        }
    }
}

/**
 * Emits a DEADLOCK sync error if detected during appointment/visit processing.
 * Centralizes deadlock error emission for consistency across services.
 * 
 * @param {boolean} hasDeadlock - Flag indicating if deadlock was detected
 * @param {string} source - Error source (ERROR_SOURCES.APPOINTMENT or ERROR_SOURCES.VISIT)
 */
export function emitDeadlockIfDetected(hasDeadlock, source) {
    if (ENABLE_SYNC_ERROR_MODAL && hasDeadlock) {
        syncErrorBus.emit(new SyncError(
            SYNC_ERROR_TYPES.DEADLOCK,
            source
        ));
    }
}
